import { createModel } from 'xstate/lib/model';

import { CompanyContextType } from 'common/hooks/useCompanyContext/types';
import baseEvents from 'features/Bento/libs/machines/config/baseEvents';

import { SasuCreationDataQuery } from '../graphql/queries/sasuCreationData.gql';
import { Service } from './services';

export type OnboardingCapitalDepositModuleData = {
  getQueryParams: () => URLSearchParams;
  companyContext: CompanyContextType;
  enableSasuActivities: boolean;
} & SasuCreationDataQuery;

const context = {
  getModuleData: (() => {
    throw new Error('NOT_IMPLEMENTED');
  }) as () => OnboardingCapitalDepositModuleData,
};

export type Context = typeof context;

const model = createModel(
  context,

  {
    events: {
      ...baseEvents,
      [`done.invoke.${Service.SubmitApplication}` as const]: () => ({}),
      DOWNLOAD_SHINE: () => ({}),
      GO_BENEFICIARIES_DOCS: () => ({}),
      REDIRECTED_TO_PARTNER: () => ({}),
      SASU_INFO_SET: () => ({}),
    },
  },
);

export default model;

export type Model = typeof model;
